import React, { useState } from 'react';
import { PageLoader, SGSAccordion, SGSButton, SGSBadge, SGSInput, SGSSelect, SGSHelpButton } from 'components';
import { useHistory } from 'react-router';
import { faqService, tagService } from 'core/services';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'core/hooks';
import { bySortOrder } from 'core/utils';
import { Grid, Box, Container, Typography } from '@material-ui/core';
import styles from '../FAQ.module.scss';
import { useAppContext } from 'core/contexts';
import { isAllowedToManagContent } from 'core/utils/roles';

type Props = {};

const FAQList: React.FC<Props> = () => {
    const history = useHistory();
    const { user } = useAppContext();
    const { t } = useTranslation();
    const [filters, setFilters] = useState<faqService.FaqFilters>();
    const { data, loading } = useQuery(faqService.getRubriquesWithFaqs, filters);
    const { data: tags } = useQuery(tagService.getTags);
    const [searchValue, setSearchValue] = useState('');
    const [selectedTags, setSelectedTags] = useState([]);

    const search = () => {
        setFilters({
            search: searchValue,
            tags: selectedTags.filter((t) => t), // On supprime les valeurs non définies...
        });
    };

    return (
        <div>
            <SGSHelpButton />
            <Box display="flex" justifyContent="center" alignItems="center" className="mb-4">
                <SGSSelect
                    label={t('help.faq.question.tag')}
                    multiple
                    options={
                        tags?.map((o) => ({
                            value: o.id.toString(),
                            label: o.name,
                        })) ?? []
                    }
                    value={selectedTags}
                    onChange={(e) => setSelectedTags(e.target.value as string[])}
                    className={styles.tagSelect}
                />
                <SGSInput className="mx-2" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} label={t('global.searchTerm')} onKeyDown={(e) => e.key === 'Enter' && search()} />
                <SGSButton onClick={() => search()}>{t('global.search')}</SGSButton>
            </Box>
            {isAllowedToManagContent(user) && (
                <div className="mb-4">
                    <SGSButton
                        className="mr-2"
                        onClick={() => {
                            history.push('/faq/questions');
                        }}
                        data-cy="manage-questions"
                    >
                        {t('help.faq.question.admin')}
                    </SGSButton>
                    <SGSButton
                        className="mr-2"
                        onClick={() => {
                            history.push('/faq/rubriques');
                        }}
                        data-cy="manage-rubriques"
                    >
                        {t('rubrique.admin')}
                    </SGSButton>
                    <SGSButton
                        onClick={() => {
                            history.push('/faq/tags');
                        }}
                        data-cy="manage-tags"
                    >
                        {t('tag.admin')}
                    </SGSButton>
                </div>
            )}
            <Container maxWidth="md">
                <PageLoader loading={loading}>
                    {data?.sort(bySortOrder).map((rubrique) => {
                        return (
                            <div key={rubrique.id} className="mb-4">
                                <Typography variant="h1" component="h2" color="primary" gutterBottom>
                                    {rubrique.name}
                                </Typography>
                                <div>
                                    {rubrique.faqs.map((rubriqueQuestion) => (
                                        <SGSAccordion key={rubriqueQuestion.faq.id} summary={<strong>{rubriqueQuestion.faq.title}</strong>}>
                                            <Grid container direction="column">
                                                <div dangerouslySetInnerHTML={{ __html: rubriqueQuestion.faq.content }}></div>
                                                {rubriqueQuestion.tags.length > 0 && (
                                                    <Grid container className="mt-2">
                                                        {rubriqueQuestion.tags.map((t) => (
                                                            <Grid item>
                                                                <SGSBadge color="darkorange">{t.name}</SGSBadge>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </SGSAccordion>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </PageLoader>
            </Container>
        </div>
    );
};

export default FAQList;
